import {Injectable, inject} from '@angular/core';
import {DOCUMENT} from '@angular/common';

const GOOGLE_TAG_LOADER_BASE_URL = 'https://www.googletagmanager.com/gtag/js?id=';

export const SMILE_HEALTH_MASTER_GOOGLE_ANALYTICS_ID = 'G-N1NRRPM9CK';

interface GoogleTagWindowInterface extends Window {
  dataLayer?: unknown[];
  googleTag?: (...args: unknown[]) => void;
}

@Injectable({providedIn: 'root'})
export class AnalyticsService {
  private _document: Document = inject(DOCUMENT);
  private _initialized: boolean = false;

  public initializeGoogleAnalytics(measurementId: string): void {
    if (this._initialized) {
      return;
    }
    this._initialized = true;
    this._injectGoogleTagScripts(measurementId);
  }

  private _injectGoogleTagScripts(measurementId: string): void {
    const googleTagWindow: GoogleTagWindowInterface | null = this._document.defaultView as GoogleTagWindowInterface | null;
    if (!googleTagWindow) {
      return;
    }

    googleTagWindow.dataLayer = googleTagWindow.dataLayer ?? [];
    googleTagWindow.googleTag = function googleTag(...args: unknown[]): void {
      (googleTagWindow.dataLayer as unknown[]).push(args);
    };
    googleTagWindow.googleTag('js', new Date());
    googleTagWindow.googleTag('config', measurementId);

    const loaderScript: HTMLScriptElement = this._document.createElement('script');
    loaderScript.async = true;
    loaderScript.src = `${GOOGLE_TAG_LOADER_BASE_URL}${encodeURIComponent(measurementId)}`;
    this._document.head.appendChild(loaderScript);
  }
}
